const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PaymentConsolidationQuery: any = {
    GetPaymentConsolidation: Backofficebff + '/v1/paymentconsolidation/get-payment-consolidation',
};
